<template>
  <view class="modal-title-slot-demo">
    <cube-modal
      wx:ref="modal"
      content="我是正文正文"
      direction="horizontal"
      confirm-btn="确认继续接单"
      cancel-btn="取消"
      mask-closable="{{ true }}"
      bind:confirm="onConfirm"
      bind:cancel="onCancel"
    >
      <view slot="title" class="modal-title-slot">我是slot标题</view>
    </cube-modal>
    <cube-button  bind:click="onTap">modal-title-slot</cube-button>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    methods: {
      onTap() {
        this.$refs.modal.show()
      },
      onConfirm() {
        console.log('click the confirm btn')
      },
      onCancel() {
        console.log('click the cancel btn')
      }
    }
  })
</script>

<style lang="stylus">
.modal-title-slot-demo
  .modal-title-slot
    margin-bottom 10px
    line-height 1.45
    font-size 22px
    font-weight bold
    color #444
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-modal": "@mpxjs/mpx-cube-ui/src/components/modal/index",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
